import { useQuery } from '@tanstack/react-query'
import { fetchData } from '../../api/fetchJson'
import { orgPath } from '../../config/orgId'
import { env } from '../../config/env'

export type DemoProject = {
  id: string
  name: string
  status?: string
  primary_site_lead_name?: string
}

export function useProjects() {
  return useQuery<DemoProject[]>({
    queryKey: ['projects', env.demoOrgId],
    enabled: Boolean(env.demoOrgId),
    queryFn: () => fetchData<DemoProject[]>(orgPath('/projects')),
  })
}
